import { Injectable } from '@angular/core';
import { Observable, interval, pipe,throwError} from 'rxjs';
import { switchMap, map, takeWhile } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient,HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LoggedinService } from '../loggedin.service';
import { catchError, retry } from 'rxjs/operators';
import {Router} from "@angular/router";


class interface_type {
}

@Injectable()
export class ApiService {

  private domain =  environment["API_URL"];
  private _url = environment["API_URL"];

  constructor(private _http: HttpClient,
              private _authHttp: HttpClient,
              public jwtHelper: JwtHelperService,
              private loggedinService: LoggedinService,
              public router: Router,){

  }

  status_code:number

  handleError(error: HttpErrorResponse) {

      if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
      } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,

        if (error.status && error.error.message){
          console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error.message}`);
        }
      }
      // return an observable with a user-facing error message

      if (error.status){
        return throwError({message:error.error.message, status_code:error.status });
      } else {
        //console.error('no status code',error)
      }
  }; //end handleError

  isTokenExpired(caller?: string){

    //const helper = new JwtHelperService();
    //const decodedToken = helper.decodeToken(localStorage.getItem('id_token'));
    //var isIdTokenExpired = helper.isTokenExpired(localStorage.getItem('id_token'));

    //const isRefreshTokenExpired = helper.isTokenExpired(localStorage.getItem('refresh_token'));

    //isIdTokenExpired=true;
    if (this.jwtHelper.isTokenExpired()==true){
      this.getRefreshCognitoTokens(caller)
    }

  }

  //ON SUBMIT CHECK IF TOKEN NEEDED REFRESHING
  getRefreshCognitoTokens(caller?: string){

    //NEED TO BACK CALL TO API TO GET REFRESH TOKEN

    this.router.navigate(['login']);
    // pool_url https://devauth.adhui.com/oauth2/token
    // let body = new URLSearchParams();
    // body.set('grant_type', 'refresh_token');
    // body.set('client_id', environment["pool_app_client_id"]);
    // body.set('refresh_token', localStorage.getItem('refresh_token'));
    //
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Conte8int-Type':  'application/x-www-form-urlencoded',
    //     'Authorization': 'Basic ' + btoa(environment['pool_app_client_id'] + ':' + environment['app_client_secret'])
    //   })
    // };

    // var result = this._http.post( environment['pool_url'], body.toString(), httpOptions)
    //     .subscribe(
    //       response => {
    //         var token_data_str = response
    //         var token_data = token_data_str //JSON.parse(token_data_str)
    //
    //         localStorage.setItem('id_token',token_data['id_token'])
    //         localStorage.setItem('access_token',token_data['access_token'])
    //
    //       },
    //       error => {
    //
    //         //let error_json = JSON.parse(error.text()) error if used - keep incase inficintie loop
    //
    //         this.loggedinService.announceLoggedin(false);
    //         window.location.href = environment['signin']
    //       }
    //     );
    //
    // return result
  } //end getRefreshCognitoTokens()

  refreshToken(){
    var result = this.getRefreshCognitoTokens()
    return result
  }

  postApiData(endpoint:string,data,is_cache_buster=true){

    if (is_cache_buster==true){
      let ran = Math.floor(Math.random() * 10000) + 1;
      var cache_buster = '?cache=' + ran.toString();
      endpoint = endpoint + cache_buster;
    }

    this.isTokenExpired()

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': localStorage.getItem('id_token')
      })
    };
    //var result =this._http.post(this.getEndpointUrl(endpoint),JSON.stringify(data),httpOptions).pipe(map(res => res));

    console.log('ARE YIU KIDDING ME????????????????????????',endpoint)
    return this._http.post(this.getEndpointUrl(endpoint), JSON.stringify(data),
      {headers: new HttpHeaders({ 'Content-Type':  'application/json','Authorization': localStorage.getItem('id_token') }),
        observe: 'response'});

    //return result;
} //end postData

  putApiData(endpoint:string,data,is_cache_buster=true){

  if (is_cache_buster==true){
    let ran = Math.floor(Math.random() * 10000) + 1;
    var cache_buster = '?cache=' + ran.toString();
    endpoint = endpoint + cache_buster;
  }

  this.isTokenExpired()

  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': localStorage.getItem('id_token')
    })
  };
  //var result =this._http.post(this.getEndpointUrl(endpoint),JSON.stringify(data),httpOptions).pipe(map(res => res));
    console.log('wtf dude',this.getEndpointUrl(endpoint))
  return this._http.put(this.getEndpointUrl(endpoint), JSON.stringify(data), {headers: new HttpHeaders({ 'Content-Type':  'application/json','Authorization': localStorage.getItem('id_token') }),observe: 'response'});

  //return result;
} //end postData


  getApiData(endpoint:string){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': localStorage.getItem('id_token')
      })
    };

    this.isTokenExpired('caller is: getApiData: ' + endpoint)

    return this._http.get(this.getEndpointUrl(endpoint), {headers: new HttpHeaders({ 'Content-Type':  'application/json','Authorization': localStorage.getItem('id_token') }),observe: 'response'}).pipe(catchError(this.handleError));

  }

  getApiDataInterface(endpoint:string,interface_type:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': localStorage.getItem('id_token')
      })
    };

    this.isTokenExpired('caller is: getApiData: ' + endpoint)

    return this._http.get<interface_type>(this.getEndpointUrl(endpoint), {headers: new HttpHeaders({ 'Content-Type':  'application/json','Authorization': localStorage.getItem('id_token') }),observe: 'response'}).pipe(catchError(this.handleError));

  }

  deleteApiData(endpoint:string){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': localStorage.getItem('id_token')
      })
    };

    this.isTokenExpired()

    return this._http.delete(this.getEndpointUrl(endpoint), {headers: new HttpHeaders({ 'Content-Type':  'application/json','Authorization': localStorage.getItem('id_token') }),observe: 'response'});

  }

  test(){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': localStorage.getItem('id_token')
      })
    };


    this.isTokenExpired()
    //http://0.0.0.0:8050//model/run/1

    let endpoint = 'model/run/1';

    //var result = this._http.get(this.getEndpointUrl(endpoint),httpOptions).pipe(map(res => res));

   return this._http.get(this.getEndpointUrl(endpoint), {headers: new HttpHeaders({ 'Content-Type':  'application/json','Authorization': localStorage.getItem('id_token') }),observe: 'response'});


  }

  deleteData(endpoint:string){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': localStorage.getItem('id_token')
      })
    };

    this.isTokenExpired()
    var result = this._http.delete(this.getEndpointUrl(endpoint),httpOptions).pipe(map(res => res));

		return result;
  } //end deleteData

  private getEndpointUrl(endpoint:string){
      return this._url + endpoint;
  }



} //end class
